// import { useState } from "react";
// import { generateToken }
// from "../services/tokenService";

// function GenerateToken() {

//   const [serviceId,
//    setserviceId]=useState("");

//  const [customerName,
//  setCustomerName]=useState("");

//  const [mobileNo,
//  setMobileNo]=useState("");

//  const submit = async()=>{

//    const result =
//    await generateToken({

//       //serviceId:1,
//       serviceId,
//       customerName,
//       mobileNo

//    });

//    alert(
//      "Token : "
//      + result.data.tokenNo
//    );
//  };

//  return(

//  <div className="container mt-4">

//   <div className="card p-4">

//    <h3>Generate Token</h3>

// {/* <input
//     className="form-control mb-3"
//     placeholder="Service Id"
//     onChange={(e)=>
//       setserviceId(
//        e.target.value)}
//    /> */}
//    <div className="row">
//   {services.map((item) => (
//     <div className="col-md-3" key={item.id}>
//       <div
//         className={`card p-3 text-center ${
//           serviceId == item.id ? "border-primary" : ""
//         }`}
//         onClick={() => setserviceId(item.id)}
//         style={{ cursor: "pointer" }}
//       >
//         <h4>{item.icon}</h4>
//         <div>{item.serviceName}</div>
//       </div>
//     </div>
//   ))}
// </div>

//    <input
//     className="form-control mb-3"
//     placeholder="Customer Name"
//     onChange={(e)=>
//       setCustomerName(
//        e.target.value)}
//    />

//    <input
//     className="form-control mb-3"
//     placeholder="Mobile"
//     onChange={(e)=>
//       setMobileNo(
//        e.target.value)}
//    />

//    <button
//     className="btn btn-success"
//     onClick={submit}
//    >
//      Generate
//    </button>

//   </div>

//  </div>

//  );
// }

// export default GenerateToken;

import { useEffect, useState } from "react";
import api from "../api/axios";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";
//import { useAuth } from "./AuthContext";
//import { useNavigate } from "react-router-dom";

function TokenGenerate() {
  //const { user, logout } = useAuth();
  const [customerName, setCustomerName] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [serviceId, setServiceId] = useState("");
  const [services, setServices] = useState([]);
  const [token, setToken] = useState(null);

  useEffect(() => {
    loadServices();
  }, []);

  const loadServices = async () => {
    try {
      const res = await api.get("/Service/services");
      setServices(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const generateToken = async () => {
    try {
      if (!customerName) {
        Swal.fire("", "Please Enter Customer Name", "warning");
        //alert("Enter Customer Name");
        return;
      }

      if (!mobileNo) {
        Swal.fire("", "Please Enter Mobile Number", "warning");
        //alert("Enter Mobile No");
        return;
      }

      if (mobileNo.length !== 10) {
        //alert("Please enter a valid 10-digit mobile number.");
        Swal.fire("", "Please Enter a Valid 10-digit Mobile Number", "warning");
        return;
      }
      if (!serviceId) {
        Swal.fire("", "Please Select Service", "warning");
        //alert("Select Service");
        return;
      }

      const res = await api.post("/Token", {
        customerName,
        mobileNo,
        serviceId,
      });

      setToken(res.data);
      setCustomerName("");
      setMobileNo("");
      setServiceId("");
    } catch (error) {
      console.error(error);
      alert("Failed to generate token");
    }
  };

  return (
    <>
 {token && (
        <div className="card mb-4 text-center">
          <div className="card-body">
            <h4>Token Generated</h4>

            <h1
              style={{
                fontSize: "50px",
                color: "green",
              }}
            >
              {token.tokenNo}
            </h1>

            <h5>{token.customerName}</h5>
          </div>
        </div>
      )}

      <div className="card shadow">
        <div className="card-header bg-primary text-white">
          <h4 className="mb-0">Generate Token</h4>
        </div>

        <div className="card-body">
          <div className="row">
            <div className="col col-md-6 col-12">
              <input
                type="text"
                className="form-control mb-3"
                placeholder="Customer Name"
                value={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
              />
            </div>

            {/* <div className="col col-md-6 col-12"><input
            type="text"
            className="form-control mb-4"
            placeholder="Mobile No"
            value={mobileNo} maxLength={10} minLength={10}
            onChange={(e) =>
              setMobileNo(e.target.value)
            }
          /></div> */}
            <div className="col col-md-6 col-12">
              <input
                type="tel"
                className="form-control mb-4"
                placeholder="Mobile No"
                value={mobileNo}
                maxLength={10}
                pattern="[6-9]{1}[0-9]{9}"
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  setMobileNo(value);
                }}
              />
            </div>
          </div>

          <div className="col col-12">
            <h5 className="mb-3">Select Service</h5>

            <div className="row">
              {services.map((item) => (
                <div className="col-md-2 mb-3 col-6" key={item.id}>
                  <div
                    className={`card text-center p-1 ${
                      serviceId === item.id ? "border-primary border-2" : ""
                    }`}
                    style={{
                      cursor: "pointer",
                      minHeight: "110px",
                    }}
                    onClick={() => setServiceId(item.id)}
                  >
                    <div
                      style={{
                        fontSize: "40px",
                      }}
                    >
                      {item.icon || "📄"}
                    </div>

                    <h6 className="mt-2">{item.serviceName}</h6>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col col-12 text-center">
            <button className="btn btn-success mt-3" onClick={generateToken}>
              <i className="bi bi-shadows"></i> Generate Token
            </button>
          </div>
        </div>
      </div>

     
    </>
  );
}

export default TokenGenerate;
